module.exports = __webpack_public_path__ + "img/shopping.b7e53316.gif";